import { render, staticRenderFns } from "./MenuModelSelector.vue?vue&type=template&id=3561d51c&"
import script from "./MenuModelSelector.vue?vue&type=script&lang=js&"
export * from "./MenuModelSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports